export enum Authority {
  ADMIN = 'ROLE_ADMIN',
  USER = 'ROLE_USER',
  CONTABLE = 'ROLE_CONTABLE',
  COBRADOR = 'ROLE_COBRADOR',
  BIBLIO = 'ROLE_BIBLIO',
  BLOG = 'ROLE_BLOG',
}
